import api from "@/lib/api";

function getCurrentPosition() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Location services aren't available on this device."));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(pos.coords),
      (err) => {
        if (err.code === err.PERMISSION_DENIED) {
          reject(new Error("Location permission denied. You can enter it manually instead."));
        } else {
          reject(new Error("Couldn't get your location. Please enter it manually."));
        }
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  });
}

// Resolves to { country, city, supported }
export async function detectCareLocation() {
  const coords = await getCurrentPosition();
  const { data } = await api.get("/care/reverse-geocode", {
    params: { lat: coords.latitude, lng: coords.longitude },
  });
  return data;
}
